import css from 'styled-jsx/css';

const styles = css`/* stylelint-disable */
:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.container {
    height: 250px;
    padding-top: 8px;
    background-color: #ffffff;
}
.row {
    height: 75px;
    margin: 8px;
    background-color: #eeeeee;
}
.lds-ring {
    position: relative;
    width: 75px;
    height: 75px;
    display: block;
    margin: auto;
    margin-top: calc(8px * 3);
}
@media screen and (prefers-reduced-motion: reduce) {
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 75px;
        height: 75px;
        margin: 6px;
        border: 6px solid #0a4c71;
        border-radius: 50%;
        -webkit-animation: none;
                animation: none;
        border-color: #0a4c71 transparent transparent transparent;
        margin-top: 50px;
    }
}
.lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 75px;
    height: 75px;
    margin: 6px;
    border: 6px solid #0a4c71;
    border-radius: 50%;
    -webkit-animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
            animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #0a4c71 transparent transparent transparent;
    margin-top: 50px;
}
.lds-ring div:nth-child(1) {
    -webkit-animation-delay: -0.45s;
            animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
    -webkit-animation-delay: -0.3s;
            animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
    -webkit-animation-delay: -0.15s;
            animation-delay: -0.15s;
}
@-webkit-keyframes lds-ring {
    0% {
        -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
    }
}
@keyframes lds-ring {
    0% {
        -webkit-transform: rotate(0deg);
                transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(360deg);
                transform: rotate(360deg);
    }
}
`;

export default styles;